import React, { Component } from "react";
import { message } from "antd";
import axios from "axios";
import { connect } from "react-redux";
import { ModalItem, ButtonItem, TextAreaItem, MensajeError } from "../../../../Components/Items";

class ModalReabrirOrdenPU extends Component {
  state = {
    loading: false,
    motivo: "",
  };

  onReabrirOrden = () => {
    this.setState({ loading: true });
    axios
      .post(
        "ordenesDeProduccionPU/reabrirOrden",
        { ordenId: this.props.ordenId, empresaId: this.props.empresaId, usuarioId: this.props.usuarioId, motivo: this.state.motivo },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success(res.data.mensaje || "Orden reabierta correctamente");
          this.setState({ motivo: "" });
          this.props.onReabierta();
        } else {
          MensajeError({ message: res.data.error || "No se pudo reabrir la orden" });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        MensajeError({ message: "Error al conectar con el servidor" });
      });
  };

  render() {
    return (
      <ModalItem
        title="Reabrir orden de producción"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.props.onCerrar}
        width="40%"
        paddingTop
        footer={null}
      >
        <div style={{ color: "#999", fontSize: 12, marginBottom: 12 }}>
          La orden vuelve a estado activo y se puede volver a mover piezas. Queda registrado quién y cuándo la reabrió.
        </div>
        <div style={{ marginBottom: 4, fontWeight: 600 }}>Motivo (opcional)</div>
        <TextAreaItem placeholder="Opcional" value={this.state.motivo} onChange={(e) => this.setState({ motivo: e.target.value })} />
        <div style={{ textAlign: "right", marginTop: 16 }}>
          <ButtonItem naranja onClick={this.onReabrirOrden}>
            Reabrir orden
          </ButtonItem>
        </div>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  usuarioId: state.user.usuarioId,
});

export default connect(mapStateToProps)(ModalReabrirOrdenPU);
